<template lang="pug">
.v-map-google.map-google
	.map-google__map(id='map')
</template>
<script>
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer } from "@googlemaps/markerclusterer";
export default {

	props: {
		items: {
			type: [Array, Object ],
			default: []
		},

		variables: {
			type: Object,
			default: {}
		},

		initParams: {
			type: Object,
			default: {}
		},

		activeMarker: {
			type: [String, Number],
			default: null
		}
	},

	emits: [
		'active-id'
	],

	data() {
		return {
			loader: new Loader({
				apiKey: "AIzaSyCaCaGpBFTPFtd9ei9VENcT-pZthD6DsmQ",
				version: "weekly",
				language: this.initParams.language || 'en'
			}),
			map: null,
			activeMarkerElement: null,
			markerCluster: null,
			markers: [],
			markersElements: []
		}
	},

	async mounted() {
		await this.initMap();
	},

	methods: {
		initMap() {

			return this.loader.load().then(async () => {
				const { Map } = await google.maps.importLibrary("maps");
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
				const map = new Map(document.getElementById("map"), {
					center: this.initParams.center || {	lat: 53.902844, lng: 27.569429},
					zoom: this.initParams.zoom || 7,
					streetViewControl: false,
					mapTypeControl: false,
					fullscreenControl: false,
					clickableIcons: false,
					mapId: '17ef86c12008cae1',
				});

				if(this.initParams?.bounds) {
					map.fitBounds({
						"south": Number(this.initParams.bounds.southwest.lat),
						"west": Number(this.initParams.bounds.southwest.lng),
						"north": Number(this.initParams.bounds.northeast.lat),
						"east": Number(this.initParams.bounds.northeast.lng)
					})
				}

				this.map = map;



				for (let i = 0; i < this.items.length; i++) {
					const markerContent = document.createElement("div");
					markerContent.className = 'marker';


					const advancedMarkerView = new AdvancedMarkerElement({
						position: this.items[i]?.location?.position,
						content: markerContent,
						collisionBehavior: 'REQUIRED_AND_HIDES_OPTIONAL'
					});
					advancedMarkerView.setMap(map);
					this.markers.push(advancedMarkerView);

					const element = advancedMarkerView.element;
					//
					// const infowindow = new google.maps.InfoWindow();
					// infowindow.setContent(this.windowContent(this.items[i]));

					const markerElement = element.querySelector(`.marker`);

					this.markersElements.push(markerElement);

					const onSelectMarker = (id = null) => {

						if(!id) {
							if(this.activeMarkerElement) {
								this.markers.forEach(marker => {
									const markerElement = marker.element.querySelector(`.marker`)
									if(markerElement) {
										markerElement.classList.remove('active')
									}
								})
							}
							markerElement.classList.add('active');
							this.activeMarkerElement = markerElement;

							this.$emit('active-id', this.items[i].id)
						} else {

							if(id === this.items[i].id) {
								if(this.activeMarkerElement) {
									this.markers.forEach(marker => {
										const markerElement = marker.element.querySelector(`.marker`)
										if(markerElement) {
											markerElement.classList.remove('active')
										}
									})
								}
								markerElement.classList.add('active');
								this.activeMarkerElement = markerElement;

								map.setZoom(15);
								map.panTo(advancedMarkerView.position)

								this.$emit('active-id', this.items[i].id)
							}
						}
					}

					element.addEventListener('pointerdown', () => onSelectMarker());
					markerElement.addEventListener('cardclick', (e) => onSelectMarker(e.detail.id));
				}


				const renderer = {
					render: ({ count, position, markers }) =>
						new AdvancedMarkerElement({
							content: this.clusterTag(count, markers, position),
							position,
						})
				};

				if(this.markers.length) {
					new MarkerClusterer({ map, markers: this.markers, renderer});
				}
			});
		},

		clusterTag(count, markers, position) {
			const clusterTag = document.createElement("div");
			clusterTag.className = 'cluster';

			clusterTag.innerHTML = `
				<div class="cluster-number">
					${count}
				</div>`

			return clusterTag;
		},

	},


	watch: {
		items() {
			this.markers.forEach(item => item.setMap(null));
			this.activeMarkerElement = null;
			this.markers = [];
			this.initMap();
		},

		activeMarker() {
			this.markersElements.forEach(marker => marker.dispatchEvent(new CustomEvent("cardclick", {
				detail: { id: this.activeMarker }
			})))
		}
	}

}

</script>